export default {
    'name': 'arrow',
    'width': '12',
    'height': '12',
    'viewBox': '0 0 12 12',
    'data': '<path fill-rule=\'evenodd\' clip-rule=\'evenodd\' d=\'M2.84476 3.85343C2.6495 3.65816 2.33292 3.65816 2.13766 3.85343C1.9424 4.04869 1.9424 4.36527 2.13766 4.56053L5.64649 8.06937C5.74026 8.16314 5.86744 8.21582 6.00005 8.21582C6.13265 8.21582 6.25983 8.16314 6.3536 8.06937L9.86243 4.56053C10.0577 4.36527 10.0577 4.04869 9.86243 3.85343C9.66717 3.65816 9.35059 3.65816 9.15533 3.85343L6.00005 7.00871L2.84476 3.85343Z\' fill=\'#42A463\'/>'
}
